import { userConstants } from '../constants';

export function registration(state = {}, action) {
    switch (action.type) {
        case userConstants.REGISTER_REQUEST:
            return { registering: true };
        case userConstants.SET_INVITATION:
            return { invited_user_info: action.payload.data.invited_user };
        case userConstants.REMOVE_INVITATION:
            return { invited_user_info: null };
        case userConstants.REGISTER_SUCCESS:
            return {};
        case userConstants.REGISTER_FAILURE:
            return {};
        default:
            return state
    }
}
